import { render, staticRenderFns } from "./recallRegistrationAction.vue?vue&type=template&id=550f1984&scoped=true"
import script from "./recallRegistrationAction.vue?vue&type=script&lang=js"
export * from "./recallRegistrationAction.vue?vue&type=script&lang=js"
import style0 from "./recallRegistrationAction.vue?vue&type=style&index=0&id=550f1984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f1984",
  null
  
)

export default component.exports